import {
  Environment
} from '@vodacom/web-env';

import {
  AppState,
  getStorageWithExpiry,
  mapSendOtp,
  mapSendUserOtp,
  mapVerifyOtp,
  mapVerifyUserOtp,
  setStorageWithExpiry
} from 'helpers';

export class AuthProvider {

  static BASE_URL = Environment.current.authHost + Environment.current.authBase;
  static STATE = AppState.with('AuthProvider');

  static getMsisdn() {
    return getStorageWithExpiry('msisdn', 'encMsisdn', '');
  }

  static async requestOtp() {

    return AuthProvider.STATE.makeServiceCall(
      `${AuthProvider.BASE_URL}otp`,
      {
        method: 'POST',
        headers: {},
        bodyParams: {
          'id': AuthProvider.getMsisdn()
        },
        mapper: mapSendOtp
      }
    )
      .then((res) => {

        if (!res.result) {

          return {
            ok: false,
            error: new Error('Error with Otp request'),
            trace: null,
            date: null,
            result: null,
            code: null,
            stamp: new Date()
          };
        }

        return res;
      })
      .catch((error) => {

        return {
          ok: false,
          error: error,
          trace: null,
          date: null,
          result: null,
          code: error?.response?.status,
          stamp: new Date()
        };
      });
  }

  static async verifyOtp(
    otp
  ) {

    return AuthProvider.STATE.makeServiceCall(
      `${AuthProvider.BASE_URL}otp/status`,
      {
        method: 'POST',
        headers: {},
        bodyParams: {
          'id': AuthProvider.getMsisdn(),
          'pto': otp
        },
        mapper: mapVerifyOtp
      }
    )
      .then((res) => {

        if (!res.result) {

          return {
            ok: false,
            error: new Error('Otp verification error'),
            trace: null,
            date: null,
            result: null,
            code: null,
            stamp: new Date()
          };
        }

        return res;
      })
      .catch((error) => {

        return {
          ok: false,
          error: error,
          trace: null,
          date: null,
          result: null,
          code: error?.response?.status,
          stamp: new Date()
        };
      });
  }

  static async requestUserOtp() {

    return AuthProvider.STATE.makeServiceCall(
      `${AuthProvider.BASE_URL}otp/user`,
      {
        method: 'POST',
        headers: {},
        bodyParams: {
          'id': AuthProvider.getMsisdn()
        },
        mapper: mapSendUserOtp
      }
    )
      .then((res) => {

        if (!res.result) {

          return {
            ok: false,
            error: new Error('Error with Otp request'),
            trace: null,
            date: null,
            result: null,
            code: null,
            stamp: new Date()
          };
        }

        setStorageWithExpiry('Msisdn', 'msisdnMasked', res?.result?.msisdnMasked);

        return res;
      })
      .catch((error) => {

        return {
          ok: false,
          error: error,
          trace: null,
          date: null,
          result: null,
          code: error?.response?.status,
          stamp: new Date()
        };
      });
  }

  static async verifyUserOtp(
    otp
  ) {

    return AuthProvider.STATE.makeServiceCall(
      `${AuthProvider.BASE_URL}otp/user/status`,
      {
        method: 'POST',
        headers: {},
        bodyParams: {
          'id': AuthProvider.getMsisdn(),
          'pto': otp
        },
        mapper: mapVerifyUserOtp
      }
    )
      .then((res) => {

        if (!res.result) {

          return {
            ok: false,
            error: new Error('Otp verification error'),
            trace: null,
            date: null,
            result: null,
            code: null,
            stamp: new Date()
          };
        }

        setStorageWithExpiry('Auth', 'token', res.result.access_token);

        return res;
      })
      .catch((error) => {

        return {
          ok: false,
          error: error,
          trace: null,
          date: null,
          result: null,
          code: error?.response?.status,
          stamp: new Date()
        };
      });
  }
}
